export default {"src":"/_next/static/media/Doc_logo.ee029366.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};